// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3aisX","checkboxCol":"Table_checkboxCol__3-RKI","emailCol":"Table_emailCol__2tPej","actionCol":"Table_actionCol__2SUow"};